import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { TAG_TYPES } from './constants';

const restBaseQuery = fetchBaseQuery({
  baseUrl: '/api/project-orchestrator/',
});

export const emptyProjectOrchestrator = createApi({
  reducerPath: 'projectOrchestrator',
  baseQuery: restBaseQuery,
  tagTypes: Object.values(TAG_TYPES),
  endpoints: () => ({}),
});
